import * as React from "react";
import type { SVGProps } from "react";
const SvgInfoSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M12 3a9 9 0 1 0 .001 18.001A9 9 0 0 0 12 3m.75 14c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-6c0-.41.34-.75.75-.75s.75.34.75.75zM12 8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInfoSolid;
